import React from 'react';
import { Body1, H4 } from '@xo-union/tk-ui-typography';

import { Gds_QuestionResponseData } from '../../generated/graphql';
import styles from './rsvpSummaryCard.scss';

interface Props {
  question: Gds_QuestionResponseData;
}

const RsvpNotesCard: React.FC<Props> = ({ question }) => {
  if (!question?.answersData?.length) return null;

  return (
    <div className={styles.rsvpNoteCard}>
      <H4> {`“${question.answersData[0]?.text}”`} </H4>
      {!!question?.answersData[0]?.responses && (
        <Body1>{`- ${question.answersData[0]?.responses[0]?.firstName} ${question.answersData[0]?.responses[0]?.lastName}`}</Body1>
      )}
    </div>
  );
};

export default RsvpNotesCard;
